import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const epochToFormattedDateTime = (
  epochMillis: string | undefined
): string => {
  try {
    // Handle undefined input
    if (!epochMillis) {
      return "No date provided";
    }

    // Validate and parse the epoch
    const milliseconds = parseInt(epochMillis);
    if (isNaN(milliseconds)) {
      return "Invalid date format";
    }

    // Create date object
    const date = new Date(milliseconds);
    if (date.toString() === "Invalid Date") {
      return "Invalid date";
    }

    // Format date and time with the specified time zone
    const dateAndTime = date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "long",
    });

    return dateAndTime;
  } catch (error) {
    return "Error formatting date";
  }
};
